import { Select, Pagination as AntdPagination } from "antd";
import styled from "styled-components";

export const SearchWrapper = styled.div`
  text-align: left;
`;

export const Option = styled(Select.Option)`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const DropdownText = styled.p<{ bold?: boolean }>`
  flex: 0.75;
  font-size: 12px;
  font-weight: ${({ bold }) => (bold ? "bold" : "normal")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  :first-child {
    flex: 1;
  }
`;

export const Flex = styled.div`
  display: flex;
`;

export const Pagination = styled(AntdPagination)`
  display: flex;
  justify-content: flex-end;
  margin: 0 1em;
`;

export const DropdownFooterActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
